/**
 * What Fill and Cut mean for THIS run, in the real layer names (spec §12.1).
 * Getting the orientation wrong inverts every volume silently, so the
 * sentence follows the picks live (and is announced politely when it
 * changes). A role with no layer yet reads as its role name.
 */
import { useTranslation } from 'react-i18next';

import type { CompareKind } from '@/lib/analyses/compare/availability';

export interface OrientationSentenceProps {
  kind: CompareKind;
  /** Role A's layer name (Design / Later survey), or its role name. */
  aName: string;
  /** Role B's layer name (As-built survey / Earlier survey), or its role name. */
  bName: string;
}

export function OrientationSentence({ kind, aName, bName }: OrientationSentenceProps) {
  const { t } = useTranslation('project');
  const vars = { a: aName, b: bName, interpolation: { escapeValue: false } };
  return (
    <p data-testid='compare-orientation' aria-live='polite' className='text-xs break-words text-muted-foreground'>
      {kind === 'survey' ? t('compareSurfaces.orientation.survey', vars) : t('compareSurfaces.orientation.design', vars)}
    </p>
  );
}
